import { LModalContentsWidthType, ModalType } from '@lib/components';
import { ModalBlockParts } from '@lib/services';
import { EmailModalComponent } from './email-modal.component';
export interface EmailPayload {
  closeShareModal: () => void;
}

export function shareEmailPayloadParts(closeModalFunc: () => void): ModalBlockParts {
  return {
    id: 'email-modal-component',
    block: EmailModalComponent,
    closeBackEnable: true,
    type: ModalType.TYPE2,
    modalWidth: LModalContentsWidthType.MODAL_PC_W600,
    payload: {
      closeShareModal: () => {
        closeModalFunc();
      },
    } as EmailPayload,
  };
}
